import { render, staticRenderFns } from "./SettingRoleForm.vue?vue&type=template&id=1abdf7fe&"
import script from "./SettingRoleForm.vue?vue&type=script&lang=js&"
export * from "./SettingRoleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports